<template>
  <h1>Sorry, this page does not exist!</h1>
  <router-link 
    class="router-link"
    :to="{name: 'home'}"
  >
    Home Page
  </router-link>

</template>


<script>


// GLOBALS
// ----------------
import router from '../router/index';
// ----------------


export default {
  name:'NotFound',
  components: {},
  props:{},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted(){}
}
</script>


<style>

</style>